import { render, staticRenderFns } from "./Excesses.vue?vue&type=template&id=d4d52432&scoped=true&"
import script from "./Excesses.vue?vue&type=script&lang=js&"
export * from "./Excesses.vue?vue&type=script&lang=js&"
import style0 from "./Excesses.vue?vue&type=style&index=0&id=d4d52432&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d52432",
  null
  
)

export default component.exports